import http from './axios'

// 查询列表
const queryPage = ({
    endDate,
    platformId,
    status,
    startDate,
    pageNo,
    pageSize }) => {
    return http.get('/manager/dailyReport/platformReport', {
        endDate,
        platformId,
        status,
        startDate,
        pageNo,
        pageSize
    })
}

const platformTodayReport = ({
    status,
    platformId 
}) => {
    return http.get('/manager/dailyReport/platformTodayReport', {
        status,
        platformId
    })
}

// 查询列表
const platformSelectList = () => {
    return http.get('/manager/platform/list')
}

// 查询列表
const qualificationStatus = () => {
    return http.get('/manager/enum/qualificationStatus')
}


export default {
    queryPage,
    platformSelectList,
    qualificationStatus,
    platformTodayReport
}